/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
/**
 * Utility function to check if the object provided is empty or not.
 * @param obj { Object }
 * @return { boolean }
 */
export const isEmptyObject = (obj: any) => {
  if (!obj) {
    throw new Error('Provide an argument to test for empty object.');
  }
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}